import React from 'react';
import {
  TruckIcon,
  MapPinIcon,
  CurrencyRubIcon,
  ArrowCircleLeftIcon,
  CheckSquareIcon,
  WrenchIcon,
} from '@fronton/icons-react';
import { IconProps } from '@fronton/icons-react/types';

type Props = IconProps & {
  name: string;
};

/* eslint-disable @typescript-eslint/no-explicit-any */
export function IconByName(props: Props) {
  const { name } = props;
  switch (name) {
    case 'TruckIcon':
      return <TruckIcon {...(props as any)} />;
    case 'MapPinIcon':
      return <MapPinIcon {...(props as any)} />;
    case 'CurrencyRubIcon':
      return <CurrencyRubIcon {...(props as any)} />;
    case 'ArrowCircleLeftIcon':
      return <ArrowCircleLeftIcon {...(props as any)} />;
    case 'CheckSquareIcon':
      return <CheckSquareIcon {...(props as any)} />;
    case 'WrenchIcon':
      return <WrenchIcon {...(props as any)} />;
    default:
      return null;
  }
}
